/**
 * @file
 * utility for exposing effect promise to the triggering action callsite.
 * this is primarily a workaround for a weakness (or "incompatability") between
 * redux-observable and other common patterns in the redux ecosystem (e.g.
 * redux-form). In the future, consider removing epics from the standard post
 * request flow. Reference: https://github.com/fubotv/frontend-web/pull/156
 */

export function handleEffect(action: any, effect: Promise<any>) {
  if (typeof action.effectHandler === 'function') action.effectHandler(effect)
}
